import React from "react";
import { Rocket, Check } from "lucide-react";
import { futureVideos } from "../mock";
import Reveal from "./Reveal";

const FutureVideos = () => {
  return (
    <section className="py-16 md:py-24" style={{ backgroundColor: "rgba(24,126,228,0.05)" }}>
      <div className="max-w-6xl mx-auto px-5 md:px-8">
        <div className="max-w-3xl">
          <Reveal>
            <div>
              <div
                className="inline-flex items-center justify-center w-14 h-14 rounded-2xl mb-5"
                style={{ backgroundColor: "#FF6C10" }}
              >
                <Rocket className="w-7 h-7 text-white" />
              </div>
              <h2 className="font-display text-3xl md:text-4xl" style={{ color: "#187EE4" }}>
                {futureVideos.title}
              </h2>
              <p className="mt-5 text-slate-600 leading-relaxed font-medium">
                {futureVideos.body}
              </p>
            </div>
          </Reveal>

          <Reveal delay={120}>
            <div className="mt-8 grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
              {futureVideos.upcoming.map((u) => (
                <div
                  key={u}
                  className="flex items-center gap-3 bg-white rounded-2xl px-5 py-4 shadow-sm hover:shadow-md transition-shadow"
                >
                  <span
                    className="flex items-center justify-center w-8 h-8 rounded-full shrink-0"
                    style={{ backgroundColor: "rgba(241,201,31,0.25)" }}
                  >
                    <Check className="w-4 h-4" style={{ color: "#FF6C10" }} />
                  </span>
                  <span className="font-bold text-slate-700">{u}</span>
                </div>
              ))}
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};

export default FutureVideos;
